import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  cardInfo: {
    backgroundColor: theme.palette.greenPantoneLight,
    padding: theme.spacing(1),
  },
  warningTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '16px',
  },
}))

export default styles
